import { useMemo } from 'react';
import useSelectedTheme from '@rsos/hooks/useSelectedTheme';
import { DARK_THEME, LIGHT_THEME } from '@rsos/theme/constants';

/**
 * Get the theme name to switch to.
 * @returns String
 */
const useThemeToSwitchTo = () => {
  const themeName = useSelectedTheme();

  return useMemo(() => {
    return themeName === LIGHT_THEME ? DARK_THEME : LIGHT_THEME;
  }, [themeName]);
};

export default useThemeToSwitchTo;
